import { Box, Button, Card, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import DistributionGraphMockUp from 'modules/project_management/components/graphs/DistributionGraph'
import EmptyState from 'modules/project_management/components/graphs/EmptyState'
import EvolutionGraphMockUp from 'modules/project_management/components/graphs/EvolutionGraph/EvolutionGraphMockUp'
import useCreateUpsellRequest, { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { ProjectsUpsellRequestSources } from '../constants'
import { useCreateUpsellNotificationMessage } from '../hooks/useCreateUpsellNotificationMessage'

export const UpsellProjectsOverviewLanding = () => {
  const { sendUpsellNotificationMessage } = useCreateUpsellNotificationMessage()
  const { create: createUpsellRequest } = useCreateUpsellRequest()

  const handleOnClick = async () => {
    sendUpsellNotificationMessage(ProjectsUpsellRequestSources.overview)

    const result = await createUpsellRequest({
      moduleRequested: AvailableModules.projects,
      featureRequested: Features.projects_overview,
      requestSource: ProjectsUpsellRequestSources.overview.toString(),
      requestReason: ValidReasons.MissingAddon,
    })

    const handled = handleResult(result, () => undefined)
    if (handled.success) {
      track(trackingEvents.projectManagement.overview.clickLandingOverviewSection, {})

      app.setFlash({
        type: 'correct',
        message: i18n.t('project_management.toasts.upsell_success'),
      })
    }
  }

  return (
    <Box gap="s32">
      <Card>
        <Card.Content>
          <Text size="400" color="grey400" weight="semibold">
            {i18n.t('project_management.graphs.evolution.time.title')}
          </Text>
          <Box
            width="full"
            paddingX="s32"
            paddingY="s64"
            flexDirection="column"
            gap="s16"
            alignItems="center"
            justifyContent="center"
            position="relative"
          >
            <EvolutionGraphMockUp />
            <Box width="full" position="absolute" gap="s16" height="full">
              <Box
                gap="s32"
                position="absolute"
                width="full"
                height="s600"
                background="lighter920"
                style={{
                  position: 'absolute',
                  opacity: '0.9', //overlaying layer that will cover the colour of the graphic
                }}
              />
            </Box>
            <Box alignItems="center" justifyContent="center" width="s400" position="absolute">
              <>
                <Box textAlign="center">
                  <EmptyState
                    title={i18n.t('project_management.overview.upgrade_plan.title')}
                    description={i18n.t('project_management.overview.upgrade_plan.description')}
                    icon="analytics-graph-lines"
                  />
                </Box>
                <Box
                  alignItems="center"
                  flexDirection="row"
                  gap="s16"
                  justifyContent="center"
                  padding="s16"
                >
                  <Button aria-label="Click me" onClick={handleOnClick} type="primary">
                    {i18n.t('project_management.overview.upgrade_plan.action')}
                  </Button>
                </Box>
              </>
            </Box>
          </Box>
        </Card.Content>
      </Card>
      <Box width="full">
        <Card>
          <Card.Content>
            <Text size="400" color="grey400" weight="semibold">
              {i18n.t('project_management.overview.upgrade_plan.distribution_graph.title_table')}
            </Text>
            <Box
              width="full"
              height="full"
              paddingX="s32"
              paddingY="s64"
              flexDirection="column"
              gap="s16"
              alignItems="center"
              justifyContent="center"
              position="relative"
            >
              <DistributionGraphMockUp />
              <Box height="s400" width="full" />
              <Box
                flexDirection="columnReverse"
                maxHeight="s300"
                minHeight="s300"
                height="s400"
                width="full"
                minWidth="s300"
                maxWidth="full"
                background="lighter920"
                position="absolute"
                style={{
                  position: 'absolute',
                  opacity: '1',
                  filter: 'blur(50px)',
                }}
              />
            </Box>
          </Card.Content>
        </Card>
      </Box>
    </Box>
  )
}
